import {GetModuleFilter, ModuleAvailableDto} from '../features/modules/models'
import {
  getMasterModuleService,
  getModulesAvailableService,
  getModulesService,
} from '../features/modules/services'

export const useModules = () => {
  const getTypeModules = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoModulo',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getModules = async (filters: GetModuleFilter) => {
    try {
      const {data: response} = await getModulesService({
        pageNumber: 1,
        size: 100,
        ...filters,
      })
      const mappedModules =
        response.data?.map((item) => ({value: item.Id, label: item.Codigo, ...item})) || []
      return mappedModules
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getModulesLav = async (filters: GetModuleFilter) => {
    try {
      const {data: response} = await getModulesService({
        pageNumber: 1,
        size: 100,
        ...filters,
      })
      const mappedModules =
        response.data?.map((item) => ({value: item.Id, label: item.Codigo, ...item})) || []
      return mappedModules
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getModulesAvailable = async (filters: ModuleAvailableDto) => {
    try {
      const {data: response} = await getModulesAvailableService({
        ...filters,
      })
      const mappedModules =
        response.data?.map((item) => ({value: item.Id, label: item.Codigo})) || []
      return mappedModules
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getGenresModule = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'Sexo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }
  const getBathroomsTypeModule = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoBanio',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getStatusModule = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoModulo',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      return mappedModuleTypes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getTypeBuildings = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoEdificacion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getModules,
    getModulesLav,
    getTypeModules,
    getGenresModule,
    getBathroomsTypeModule,
    getStatusModule,
    getModulesAvailable,
    getTypeBuildings,
  }
}
